export const SPR = {
  hero: ["..OOOOOOO..", ".OHHHHHHHO.", ".ONNNNNNNO.", ".OBEBBBEBO.", ".OBWEBWEBO.", ".OBWEBWEBO.", ".OPBBBBBPO.", "GOBBBMBBBOG", "GOWWWWWWWOG", ".ODDDDDDDO.", ".OOOOOOOOO."],
  heroHappy: ["..OOOOOOO..", ".OHHHHHHHO.", ".ONNNNNNNO.", ".OBBBBBBBO.", ".OBEBBBEBO.", ".OEBEBEBEO.", ".OPBBBBBPO.", "GOBMMMMMBOG", "GOWWWWWWWOG", ".ODDDDDDDO.", ".OOOOOOOOO."],
  toast: [".CCCCCC.", "CCFFFFCC", "CFFWFFFC", "CFFFFFFC", "CFFFFFFC", "CFFFFFFC", "CFFFFFFC", "CCCCCCCC"],
  heart: [".RR.RR.", "RRWRRRR", "RRRRRRR", ".RRRRR.", "..RRR..", "...R..."],
};

export const PAL = {
  O: "#713F12", H: "#FEF08A", B: "#FDE047", S: "#EAB308", E: "#111827", P: "#FB7185", M: "#7F1D1D",
  C: "#B45309", F: "#FDE68A", W: "#FFFFFF", R: "#EF4444", N: "#E11D48", D: "#DC2626", G: "#F8FAFC",
};

export const drawSprite = (ctx, rows, x, y, s, pal = PAL) => {
  const w = rows[0].length * s;
  const h = rows.length * s;
  const ox = Math.round(x - w / 2);
  const oy = Math.round(y - h / 2);
  rows.forEach((row, j) => {
    for (let i = 0; i < row.length; i++) {
      const c = row[i];
      if (c === ".") continue;
      ctx.fillStyle = pal[c];
      ctx.fillRect(ox + i * s, oy + j * s, s, s);
    }
  });
};

const eyes = (ctx, x, y, gap, ang, size = 3, color = "#fff") => {
  const lx = Math.cos(ang) * 1.5;
  const ly = Math.sin(ang) * 1.5;
  [-gap, gap].forEach((dx) => {
    ctx.fillStyle = color;
    ctx.fillRect(x + dx - size, y - size, size * 2, size * 2);
    ctx.fillStyle = "#111";
    ctx.fillRect(Math.round(x + dx - 1 + lx), Math.round(y - 1 + ly), 2, 2);
  });
};

const blob = (ctx, x, y, rx, ry, color) => {
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.ellipse(x, y, rx, ry, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = "rgba(0,0,0,0.55)"; ctx.lineWidth = 2; ctx.stroke();
  ctx.fillStyle = "rgba(255,255,255,0.28)"; ctx.fillRect(Math.round(x - rx * 0.55), Math.round(y - ry * 0.65), Math.max(3, Math.round(rx * 0.4)), 3);
};

export const drawEnemy = (ctx, e, t, ang) => {
  const flash = e.hitT > 0;
  const { x, y, r } = e;
  ctx.fillStyle = "rgba(0,0,0,0.3)";
  ctx.fillRect(x - r, y + r - 2, r * 2, 4);
  if (e.type === "crumb") {
    blob(ctx, x, y, r, r - 1, flash ? "#fff" : "#B45309");
    ctx.fillStyle = "#78350F";
    ctx.fillRect(x - 6, y + 3, 3, 3); ctx.fillRect(x + 4, y - 7, 3, 3);
    eyes(ctx, x, y - 2, 4, ang, 2);
    ctx.fillStyle = "#111"; ctx.fillRect(x - 5, y - 6, 4, 2); ctx.fillRect(x + 2, y - 6, 4, 2);
  } else if (e.type === "jam") {
    const sq = 1 + Math.sin(t * 10 + e.seed) * 0.15;
    blob(ctx, x, y + (1 - sq) * 6, r * sq, r / sq, flash ? "#fff" : "#8B5CF6");
    ctx.fillStyle = "#C4B5FD"; ctx.fillRect(x - 6, y - 7, 4, 3);
    eyes(ctx, x, y - 1, 4, ang, 2);
  } else if (e.type === "mold") {
    blob(ctx, x, y, r, r, flash ? "#fff" : "#10B981");
    ctx.fillStyle = "#065F46";
    for (let i = 0; i < 6; i++) {
      const a = i + t * 0.5;
      ctx.fillRect(x + Math.cos(a) * (r + 1) - 2, y + Math.sin(a) * (r + 1) - 2, 4, 4);
    }
    ctx.fillRect(x - 7, y + 4, 4, 4); ctx.fillRect(x + 5, y + 2, 3, 3);
    eyes(ctx, x, y - 3, 5, ang, 3, "#D1FAE5");
  } else if (e.type === "turret") {
    ctx.fillStyle = flash ? "#fff" : "#64748B";
    ctx.fillRect(x - 14, y - 11, 28, 22);
    ctx.fillStyle = "#334155"; ctx.fillRect(x - 14, y + 7, 28, 4);
    ctx.fillStyle = e.fireT < 0.4 ? "#F97316" : "#7F1D1D";
    ctx.fillRect(x - 9, y - 11, 7, 3); ctx.fillRect(x + 2, y - 11, 7, 3);
    eyes(ctx, x, y - 1, 6, ang, 2, "#FCA5A5");
  } else if (e.type === "ghost") {
    ctx.globalAlpha = 0.75;
    ctx.fillStyle = flash ? "#fff" : "#292524";
    ctx.fillRect(x - r, y - r, r * 2, r * 2 - 3);
    for (let i = 0; i < 4; i++) {
      const h = Math.sin(t * 8 + i) > 0 ? 4 : 1;
      ctx.fillRect(x - r + i * (r / 2), y + r - 3, r / 2, h);
    }
    ctx.fillStyle = "#57534E"; ctx.fillRect(x - r, y - r, r * 2, 3);
    ctx.globalAlpha = 1;
    eyes(ctx, x, y - 2, 4, ang, 2, "#FDE047");
  }
};

export const drawBoss = (ctx, b, t, ang) => {
  const { x, y } = b;
  const bob = Math.sin(t * 3) * 3;
  const flash = b.hitT > 0;
  ctx.fillStyle = "rgba(0,0,0,0.35)";
  ctx.fillRect(x - 32, y + 30, 64, 6);
  ctx.fillStyle = flash ? "#fff" : "#CBD5E1";
  ctx.fillRect(x - 34, y - 26 + bob, 68, 52);
  ctx.fillStyle = "#94A3B8"; ctx.fillRect(x - 34, y + 16 + bob, 68, 10);
  ctx.fillStyle = "#475569"; ctx.fillRect(x + 34, y - 6 + bob, 6, 14);
  const glow = b.enraged ? "#EF4444" : "#F97316";
  ctx.fillStyle = Math.sin(t * 12) > 0 ? glow : "#7F1D1D";
  ctx.fillRect(x - 24, y - 26 + bob, 18, 5); ctx.fillRect(x + 6, y - 26 + bob, 18, 5);
  eyes(ctx, x, y - 6 + bob, 12, ang, 5, "#FECACA");
  ctx.fillStyle = "#111"; ctx.fillRect(x - 18, y - 15 + bob, 12, 3); ctx.fillRect(x + 6, y - 15 + bob, 12, 3);
  ctx.fillStyle = "#1F2937"; ctx.fillRect(x - 12, y + 6 + bob, 24, 5);
};

const PX_SKINS = {
  chef_hat: [["#F8FAFC", -9, -29, 18, 8], ["#F8FAFC", -12, -35, 24, 7], ["#CBD5E1", -9, -22, 18, 3]],
  knight_armor: [["#94A3B8", -15, -24, 30, 7], ["#475569", -11, -17, 22, 2], ["#EF4444", -2, -32, 4, 8], ["#CBD5E1", -14, 3, 28, 6]],
  pirate_hat: [["#111827", -18, -24, 36, 4], ["#111827", -11, -33, 22, 9], ["#F8FAFC", -2, -30, 4, 4]],
  cool_shades: [["#0B0F1A", -11, -10, 9, 6], ["#0B0F1A", 1, -10, 9, 6], ["#0B0F1A", -2, -9, 3, 2]],
  wizard_hat: [["#7C3AED", -14, -24, 28, 4], ["#7C3AED", -9, -30, 18, 6], ["#7C3AED", -6, -36, 12, 6], ["#7C3AED", -3, -41, 6, 5], ["#FDE047", -2, -32, 4, 3]],
  royal_crown: [["#F59E0B", -10, -25, 20, 5], ["#F59E0B", -10, -30, 4, 5], ["#F59E0B", -2, -32, 4, 7], ["#F59E0B", 6, -30, 4, 5], ["#EF4444", -1, -24, 3, 3]],
  cowboy_hat: [["#92400E", -18, -23, 36, 4], ["#92400E", -10, -31, 20, 8], ["#451A03", -10, -25, 20, 2]],
  viking_helmet: [["#94A3B8", -12, -26, 24, 6], ["#F8FAFC", -18, -33, 5, 9], ["#F8FAFC", 13, -33, 5, 9], ["#64748B", -12, -21, 24, 2]],
  ninja_mask: [["#1E293B", -12, -3, 24, 6]],
  superhero_cape: [["#DC2626", -17, -12, 4, 24], ["#DC2626", 13, -12, 4, 24], ["#FDE047", -3, 4, 6, 4]],
};
const PX_BAND = { chef_hat: "#F8FAFC", knight_armor: "#64748B", pirate_hat: "#111827", cool_shades: "#F97316", wizard_hat: "#7C3AED", royal_crown: "#FBBF24", cowboy_hat: "#92400E", viking_helmet: "#475569", ninja_mask: "#0F172A", superhero_cape: "#2563EB" };

export const drawHero = (ctx, p, t, happy = false, skin = null) => {
  const step = Math.floor(p.walk * 10) % 2;
  const band = PX_BAND[skin] || PAL.N;
  ctx.fillStyle = "rgba(0,0,0,0.3)";
  ctx.fillRect(p.x - 13, p.y + 15, 26, 4);
  ctx.fillStyle = "#713F12";
  ctx.fillRect(p.x - 9, p.y + 12 + (step ? 1 : 0), 6, 4);
  ctx.fillRect(p.x + 3, p.y + 12 + (step ? 0 : 1), 6, 4);
  const back = Math.cos(p.face || 0) > 0 ? -1 : 1, flap = Math.floor(t * 8) % 2;
  ctx.fillStyle = band;
  ctx.fillRect(p.x + back * 15 - (back < 0 ? 5 : 0), p.y - 14 + flap, 5, 3);
  ctx.fillRect(p.x + back * 19 - (back < 0 ? 4 : 0), p.y - 12 - flap, 4, 3);
  drawSprite(ctx, happy ? SPR.heroHappy : SPR.hero, p.x, p.y - 4, 3, { ...PAL, N: band });
  (PX_SKINS[skin] || []).forEach(([c, dx, dy, w, h]) => { ctx.fillStyle = c; ctx.fillRect(p.x + dx, p.y + dy, w, h); });
};

export const drawWeapon = (ctx, x, y, ang, w, len) => {
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(ang);
  ctx.fillStyle = "#713F12";
  ctx.fillRect(8, -2, 8, 4);
  ctx.fillStyle = w.color;
  ctx.fillRect(16, -w.width / 2, len, w.width);
  if (w.name === "Dinner Fork") {
    [-4, 0, 4].forEach((o) => ctx.fillRect(16 + len, o - 1, 6, 2));
  } else if (w.name === "Baguette Sword") {
    ctx.fillStyle = "#FDE68A";
    for (let i = 6; i < len; i += 9) ctx.fillRect(16 + i, -1, 4, 2);
  } else if (w.name === "Golden Spatula") {
    ctx.fillRect(16 + len - 4, -9, 14, 18);
    ctx.fillStyle = "#FEF08A"; ctx.fillRect(16 + len, -6, 2, 12);
  }
  ctx.restore();
};
